// extracted by mini-css-extract-plugin
module.exports = {"userIcon":"style_userIcon__18i6C","logoutIcon":"style_logoutIcon__2mi6A"};